const isLive = process.env.REACT_APP_ENVIRONMENT === "PRODUCTION";

const SDK = {
  BASE_URL: isLive
    ? process.env.REACT_APP_BASE_URL
    : process.env.REACT_APP_BASE_URL_DEV,

  SOCKET_URL: process.env.REACT_APP_SOCKET_URL,
  STRIPE_KEY: isLive
    ? process.env.REACT_APP_STRIPE_KEY_LIVE
    : process.env.REACT_APP_STRIPE_KEY_TEST,

  FB_PIXEL_ID: process.env.REACT_APP_FB_PIXEL_ID,
  TIK_TOK_PIXEL_ID: process.env.REACT_APP_TIK_TOK_PIXEL_ID,
  FB_CURRNECY: "USD",
  FB_PRICE: "29",
  mailchimpPriceTag: "29$",
  APPLE_PAY_PRICE: 2900,
  APPLE_PAY_CURRENCY: "usd",
  REGION_CONFIG: {
    uk: {
      currency: "gbp",
      price: 2900,
      countryCode: "GB",
      currSymbol: "£",
      text: "",
    },
    eu: {
      currency: "eur",
      price: 2900,
      countryCode: "DE",
      currSymbol: "€",
      text: "",
    },
    us: {
      currency: "usd",
      price: 2900,
      countryCode: "US",
      currSymbol: "$",
      text: "Prices are in USD.",
    },
  },
};

export default SDK;
